export enum Breakpoints {
    sm = 320, // Small screens
    md = 600, // Medium screens
    lg = 896, // Large screens
    xl = 1188 // Extra large screens
}
